import { Lock } from 'lucide-react';
import { Badge } from '../../../components/ui/badge';
import type { AttachTarget } from '../../../types/metaAdDraft';
import { destinationLabel } from '../liveAdSetFlow';

// Read-only summary of the live ad set a new ad is being added to. The target is
// locked server-side after creation; this is the AM's reminder of what it is.
export function AttachTargetSummary({ target }: { target: AttachTarget }) {
  return (
    <section className="rounded-md border border-slate-200 bg-slate-50 p-4" aria-label="Target ad set">
      <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-slate-800">
        <Lock className="h-4 w-4 text-slate-400" aria-hidden="true" />
        Adding an ad to a live ad set
      </div>
      <dl className="grid grid-cols-[7rem_1fr] gap-x-3 gap-y-1.5 text-sm">
        <dt className="text-xs font-medium text-slate-500">Campaign</dt>
        <dd className="text-slate-800">{target.campaignName || target.campaignId}</dd>
        <dt className="text-xs font-medium text-slate-500">Ad set</dt>
        <dd className="text-slate-800">{target.adSetName || target.adSetId}</dd>
        <dt className="text-xs font-medium text-slate-500">Destination</dt>
        <dd>
          <Badge variant={target.destination === 'unknown' ? 'warning' : 'neutral'}>{destinationLabel(target.destination)}</Badge>
        </dd>
        {target.sourceAdName && (
          <>
            <dt className="text-xs font-medium text-slate-500">Started from</dt>
            <dd className="text-slate-800">{target.sourceAdName}</dd>
          </>
        )}
      </dl>
      <p className="mt-3 text-xs text-slate-500">
        The ad set, its audience, budget, schedule and its other ads are not changed. Page and Instagram identity come
        from the ad you started from.
      </p>
    </section>
  );
}
